module.exports = __webpack_public_path__ + "static/media/datamining.4d534fe5.pdf";